export class ListaAliadosCanales {
    idAliado: number;
    idCanal: number;
}